<div class="d-flex align-items-center mx-2">
  <div class="navy-font d-flex align-items-center font-weight-bold">
    Gift Card Code:
    <div class="flex-grow-1 ml-2">
      <mat-form-field [floatLabel]="'never'" [ngClass]="{ 'text-danger': errorMessage }">
        <input #gcNumber matInput [formControl]="gcCodeForm" autocomplete="off" />
      </mat-form-field>
    </div>
  </div>
  <div class="ml-2">
    <button
      type="button"
      class="btn btn-sm em-btn em-btn-green"
      (click)="findGiftCard()"
      [disabled]="gcCodeForm.invalid || disabled"
    >
      Find
    </button>
  </div>
  <div
    *ngIf="giftCard"
    class="navy-font d-flex align-items-center font-weight-bold bigger ml-2"
    [ngClass]="{ 'text-danger': !disabled && (isBalanceTooLow() || errorMessage) }"
  >
    Balance:
    <div class="flex-grow-1 ml-2">
      {{ giftCard.balance | currency }}
    </div>
  </div>
  <div *ngIf="errorMessage" class="text-danger font-weight-bold ml-2">
    {{ errorMessage }}
  </div>
</div>
